import axios from 'axios'
import { genURL } from "../../_getjson";

export default async function checkName(txt) {
    if (txt) {
        let rs = ""
        let Url = genURL("PSCHEACKKM/GetByCode?txt=" + txt)
        console.log(Url);
        await axios.get(Url, { timeout: 3600 }).then((res) => {
            if (res.data.length === 1) {
                rs = res.data[0].MYNAMETH
            }
        }).catch((err) => {
            console.log(err);
        });
        return rs
    } 
};